import printJS from "print-js";

export const printFile = async (fileUrl: string) => {
  if (!fileUrl || !fileUrl.trim()) {
    throw new Error("FILE_URL_EMPTY");
  }

  const baseUrl = process.env.REACT_APP_BACKEND_PRINT_URL;
  const isInternalFile = fileUrl?.startsWith("file_server");

  try {
    // 👉 CASE 1: internal file → fetch → blob
    if (isInternalFile) {
      const resolvedUrl = `${baseUrl}${fileUrl}`;
      const response = await fetch(resolvedUrl);

      if (!response.ok) {
        if (response.status === 404) {
          throw new Error("FILE_NOT_FOUND");
        }

        throw new Error(`FETCH_FAILED_${response.status}`);
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      return new Promise((resolve, reject) => {
        printJS({
          printable: blobUrl,
          type: "pdf",
          onPrintDialogClose: () => {
            URL.revokeObjectURL(blobUrl);
            resolve(true);
          },
          onError: (err: any) => {
            URL.revokeObjectURL(blobUrl);
            reject(err);
          },
        });
      });
    }

    // 👉 CASE 2: external / presigned URL → use directly (NO fetch)
    return new Promise((resolve, reject) => {
      printJS({
        printable: fileUrl,
        type: "pdf",
        onPrintDialogClose: () => resolve(true),
        onError: (err: any) => reject(err),
      });
    });
  } catch (err) {
    console.error("Error printing file:", err);
  }
};

// พิมพ์ PDF ที่ BE ส่งมาเป็น base64 (เช่น ใบเสร็จจาก pack/get_receipt) → blob → print
export const printBase64Pdf = (base64: string) => {
  if (!base64 || !base64.trim()) {
    throw new Error("FILE_BASE64_EMPTY");
  }

  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  const blobUrl = URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));

  return new Promise((resolve, reject) => {
    printJS({
      printable: blobUrl,
      type: "pdf",
      onPrintDialogClose: () => {
        URL.revokeObjectURL(blobUrl);
        resolve(true);
      },
      onError: (err: any) => {
        URL.revokeObjectURL(blobUrl);
        reject(err);
      },
    });
  });
};
